import { useScroll, useSpring, motion } from "framer-motion";

export default function ScrollProgress() {
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, {
        stiffness: 100,
        damping: 30,
        restDelta: 0.001,
    });

    return (
        <motion.div
            style={{
                scaleX,
                transformOrigin: "0%",
                background: "linear-gradient(90deg, #5ABAFF, #0099FF, #0055CC)",
            }}
            className="fixed top-0 left-0 right-0 h-[2px] z-[200] pointer-events-none"
        />
    );
}
